import { useTranslation } from 'react-i18next'

import {
  Typography,
  TypographyVariant,
  TypographyWeight,
} from 'src/components/atoms'
import { SearchBar } from 'src/components/molecules'

import { CompanyDetailModal } from './components/company-detail-modal'
import { CompanyGrid } from './components/company-grid'
import { CompanyGridSkeleton } from './components/company-grid-skeleton'
import { EmptyState } from './components/empty-state'
import { ErrorState } from './components/error-state'
import { IWhyWeInvestTemplateProps } from './types'

export const WhyWeInvestTemplate = ({
  state,
}: IWhyWeInvestTemplateProps): JSX.Element => {
  const { t } = useTranslation()
  const {
    query,
    setQuery,
    filteredCompanies,
    hasResults,
    isLoading,
    isError,
    refetch,
    selectedCompany,
    openCompany,
    closeCompany,
  } = state

  return (
    <main className="bg-surface-page">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-10 px-6 py-11 md:px-12 xl:px-0">
        <header className="flex flex-col gap-4">
          <Typography
            variant={TypographyVariant.headline}
            weight={TypographyWeight.light}
            className="text-content-primary"
          >
            {t('whyWeInvest.pageTitle')}
          </Typography>
          <div className="h-px w-full bg-content-secondary" />
          <Typography
            variant={TypographyVariant.bodyXl}
            weight={TypographyWeight.light}
            className="text-content-secondary"
          >
            {t('whyWeInvest.subtitle')}
          </Typography>
        </header>

        <SearchBar
          value={query}
          onChange={setQuery}
          name="company-search"
          placeholder={t('whyWeInvest.searchPlaceholder')}
          ariaLabel={t('whyWeInvest.searchAriaLabel')}
        />

        {isLoading ? (
          <CompanyGridSkeleton />
        ) : isError ? (
          <ErrorState onRetry={refetch} />
        ) : hasResults ? (
          <CompanyGrid companies={filteredCompanies} onSelect={openCompany} />
        ) : (
          <EmptyState />
        )}
      </div>

      <CompanyDetailModal
        company={selectedCompany}
        isOpen={Boolean(selectedCompany)}
        onClose={closeCompany}
      />
    </main>
  )
}
